import batch15 from "../images/batch15.png";
import batch14 from "../images/batch14.png";
import batch13 from "../images/batch13.png";
import batch12 from "../images/batch12.png";
import batch11 from "../images/batch11.png";
import batch10 from "../images/batch10.png";
import batch9 from "../images/batch9.png";
import batch8 from "../images/batch8.png";
import batch7 from "../images/batch7.png";
import batch6 from "../images/batch6.png";
import batch5 from "../images/batch5.png";
import batch4 from "../images/batch4.png";
import batch3 from "../images/batch3.png";
import batch2 from "../images/batch2.png";
import batch1 from "../images/batch1.png";


export const services = [
  {
    id: 1,
    title: "Batch 15",
    image: batch15,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis management system (STMS)",
    pro2: "Attendance and parking automation system",
    pro3: "Chatbot in Python",
    link: "/batchDetails",
  },
  {
    id: 2,
    title: "Batch 14",
    image: batch14,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 3,
    title: "Batch 13",
    image: batch13,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 4,
    title: "Batch 12",
    image: batch12,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 5,
    title: "Batch 11",
    image: batch11,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 6,
    title: "Batch 10",
    image: batch10,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 7,
    title: "Batch 9",
    image: batch9,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 8,
    title: "Batch 8",
    image: batch8,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 9,
    title: "Batch 7",
    image: batch7,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 10,
    title: "Batch 6",
    image: batch6,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 11,
    title: "Batch 5",
    image: batch5,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 12,
    title: "Batch 4",
    image: batch4,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 13,
    title: "Batch 3",
    image: batch3,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 14,
    title: "Batch 2",
    image: batch2,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
  {
    id: 15,
    title: "Batch 1",
    image: batch1,
    students: "15",
    projectNo: "3",
    pro1: "Synopsis & Thesis managment system (STMS) ",
    pro2: "Attendence and parking automation system ",
    pro3: "Chatbot in pyhton ",
    link: "details.html",
  },
];
